/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Berateravailabilities1Inputs */

const en__field_berateravailabilities1 = /** @type {(inputs: _Field_Berateravailabilities1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availibility counselors`)
};

const de__field_berateravailabilities1 = /** @type {(inputs: _Field_Berateravailabilities1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfügbarkeit Berater`)
};

/**
* | output |
* | --- |
* | "Availibility counselors" |
*
* @param {_Field_Berateravailabilities1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_berateravailabilities1 = /** @type {((inputs?: _Field_Berateravailabilities1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Berateravailabilities1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_berateravailabilities1(inputs)
	return de__field_berateravailabilities1(inputs)
});
export { _field_berateravailabilities1 as "_field_beraterAvailabilities" }